<!-- @format -->

<div class="clear">
  <ul class="tree-list tree-list-study-plan clearfix">
    <li class="{{ classes }}">
      <div
        class="module-border"
        [class.collapsed]="!isOpen"
        [class.module-border-selected]="uiStateObject.selectedModule?.id === education.id">
        <div class="tree-list-heading tree-list-heading-has-children clearfix no-padding" ng-class="$ctrl.moduleTargetStates()">
          <div
            class="accordion-panel accordion-panel-long-title clickable"
            [class.accordion-panel-primary]="uiStateObject.selectedModule?.id === education.id"
            [class.accordion-panel-noblock]="uiStateObject.selectedModule?.id !== education.id">
            <div class="header has-header-items">
              <button
                type="button"
                class="collapse non-button"
                (click)="isOpen = !isOpen"
                [class.collapsed]="isOpen"
                [attr.aria-expanded]="isOpen"
                [attr.aria-label]="education.name | localizedString">
                <sis-icon icon="chevron-ring-fill" [iconClass]="isOpen ? 'cw-90' : null"></sis-icon>
              </button>
              <div class="title" (click)="handleHeaderClick()">
                <span class="plan-module-name">{{ education.name | localizedString }}</span>
                <span class="additional">
                  @if (education.documentState !== "ACTIVE") {
                    <span
                      class="tiny-badge"
                      [class.accent]="education.documentState === 'DRAFT'"
                      [class.danger]="education.documentState === 'DELETED'"
                      [translate]="'VISIBLE_DOCUMENT_STATE.' + education.documentState">
                    </span>
                  }
                  {{ education.code }}
                </span>
              </div>
              @if (educationValidationResult.state !== "ATTAINED") {
                <div class="cell status">
                  @if (educationValidationResult.state === "INVALID") {
                    <div
                      [class.state-gray]="uiStateObject.selectedModule?.id === education.id"
                      [class.state-invalid]="uiStateObject.selectedModule?.id !== education.id">
                      <sis-icon icon="alert-fill"></sis-icon>
                      <span translate="SIS_COMPONENTS.PLAN_STATE.INVALID"></span>
                    </div>
                  }
                  @if (educationValidationResult.state !== "INVALID") {
                    <div class="state">
                      {{ "SIS_COMPONENTS.PLAN_STATE." + educationValidationResult.state | translate }}
                    </div>
                  }
                </div>
                <div class="cell module-credits"></div>
              }
            </div>
          </div>
        </div>
        @if (isOpen) {
          <div class="tree-list-body" [class.collapsed]="!isOpen">
            <div class="row">
              @for (courseUnitId of planStateObject.education.selectedCourseUnitIds; track courseUnitId) {
                @if (!planStateObject.courseUnits[courseUnitId].isSubstituted) {
                  <sis-plan-course-unit
                    [courseUnit]="planData.courseUnitsById[courseUnitId]"
                    [parentModule]="education"
                    [planValidationResult]="planValidationResult"
                    [planStateObject]="planStateObject"
                    [planData]="planData">
                  </sis-plan-course-unit>
                }
                @if (planStateObject.courseUnits[courseUnitId].isSubstituted) {
                  <div [class.courseunit-substitution-group]="planStateObject.courseUnits[courseUnitId].substitutedBy.length > 1">
                    @for (substituteCourseUnitId of planStateObject.courseUnits[courseUnitId].substitutedBy; track substituteCourseUnitId) {
                      <sis-plan-course-unit
                        [courseUnit]="planData.courseUnitsById[substituteCourseUnitId]"
                        [planValidationResult]="planValidationResult"
                        [planStateObject]="planStateObject"
                        [planData]="planData"
                        [substitutedCourseUnitId]="courseUnitId"></sis-plan-course-unit>
                    }
                  </div>
                }
              }
              @for (customStudyDraftId of planStateObject.education.selectedCustomStudyDraftIds; track customStudyDraftId) {
                <sis-plan-custom-study-draft
                  [customStudyDraft]="planData.customStudyDraftsById[customStudyDraftId]"></sis-plan-custom-study-draft>
              }
              @for (
                customCourseUnitAttainmentId of planStateObject.education.selectedCustomCourseUnitAttainmentIds;
                track customCourseUnitAttainmentId
              ) {
                <sis-plan-custom-course-unit-attainment
                  [customCourseUnitAttainment]="$any(planData.attainmentsById[customCourseUnitAttainmentId])"
                  [planStateObject]="planStateObject"></sis-plan-custom-course-unit-attainment>
              }
            </div>
          </div>
        }
        @if (isOpen) {
          <div>
            @for (moduleId of planStateObject.education.selectedModuleIds; track moduleId) {
              <sis-plan-module
                [module]="planData.modulesById[moduleId]"
                [planValidationResult]="planValidationResult"
                [planStateObject]="planStateObject"
                [planData]="planData"
                [uiStateObject]="uiStateObject"
                [isImplicit]="false"
                [level]="level + 1"></sis-plan-module>
            }
            @for (customModuleAttainmentId of planStateObject.education.selectedCustomModuleAttainmentIds; track customModuleAttainmentId) {
              <sis-plan-custom-module-attainment
                [customModuleAttainment]="$any(planData.attainmentsById[customModuleAttainmentId])"
                [planStateObject]="planStateObject"
                [planData]="planData"
                [uiStateObject]="uiStateObject"
                [level]="level + 1"></sis-plan-custom-module-attainment>
            }
          </div>
        }
      </div>
    </li>
  </ul>
</div>
